/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import * as queryString from 'query-string'
import moment from 'moment'

const stringifyPickerRanges = (end, start) =>
  queryString.stringify({
    endDate: moment(end).set({ hour: 23, minute: 59, second: 59 }),
    startDate: moment(start).set({ hour: 0, minute: 0, second: 0 }),
  })

export default stringifyPickerRanges
